<template>
  <atoms-card
    class="text-center"
    size="md"
    :class="{
      'bg-semantic-inverse-surface text-semantic-inverse-on-surface px-5 pb-6': theme === 'dark',
      'text-semantic-surface-on-surface bg-semantic-surface-container-lowest border-1 border-semantic-outline-variant': theme === 'default'
    }"
    rounded="xl"
    shadow="none"
    theme="plain"
    :data-testid="dataTestid"
  >
    <!-- eslint-disable vue/no-v-html -->
    <p
      :class="{
        'text-semantic-inverse-primary': theme === 'dark'
      }"
      class="mt-0 mb-4 text-1.5xl leading-6"
      v-html="title"
    >
    </p>

    <hr
      v-show="theme === 'default'"
      class="border-0 border-b border-semantic-outline-variant"
    />

    <p class="text-sm leading-6 mt-2 font-bold">
      {{ subTitle }}
    </p>

    <div
      class="grid grid-cols-4 md:grid-cols-10 lg:grid-cols-4 gap-y-2.5 mt-4"
      :class="{
        'gap-x-2': theme == 'default',
        'gap-x-4': theme == 'dark'
      }"
    >
      <div
        v-for="n in 44"
        :key="n"
        class="col-lg-3 col-md-3 col-sm-3"
      >
        <atoms-cta
          :id="`cta-sidebar-${ n + 39 }`"
          target="_self"
          :to="`${ formUrl }?age=${ n === 1 ? '35' : n === 44 ? '84' : n + 39 }`"
          :theme="theme === 'dark' ? 'tertiary2' : 'primaryWhite'"
          :class="pillClass"
          size="medium"
          rounded="standard"
        >
          {{ n === 1 ? '<' : '' }}
          {{ n + 39 }}
          {{ n === 44 ? '>' : '' }}
        </atoms-cta>
      </div>
    </div>

    <p
      class="mb-0 font-thin pt-6"
      :class="{
        'text-sm' : theme === 'default',
        'text-xs': theme === 'dark'
      }"
    >
      {{ disclaimer }}
    </p>
  </atoms-card>
</template>

<script setup>
defineOptions({
  name: 'V2MoleculesAgeCta'
})

const props = defineProps({
  dataTestid: {
    type: String,
    default: 'age-cta'
  },

  title: {
    type: String,
    default: '<strong>Select your age</strong> <br class="hidden lg:block"/> <span class="text-1.5xl"> and </span> <br class="block md:hidden"/> <strong>compare now!</strong>'
  },

  subTitle: {
    type: String,
    default: 'We’ll show best quotes for you'
  },

  componentVertical: {
    type: String,
    default: 'Health Insurance'
  },

  customComponent: {
    type: Object,
    default: () => ({})
  },

  theme: {
    type: String,
    default: 'default'
  },

  disclaimer: {
    type: String,
    default: '*Average savings based on 136,746 customers between 1 Jan 2018 - 23 December 2022'
  }
})

const formUrlMap = {
  'Health Insurance': '/health-insurance/quote/form/step1/',
  'Life Insurance': '/life-insurance/quote/form/step1/',
  Energy: '/energy/quote/form/step1/',
  'Home Loans': '/home-loans/quote/form/step1/'
}

const formUrl = computed(() => {
  const { componentVertical, customComponent } = props
  const customUrl = customComponent.to

  if (!customUrl) {
    return formUrlMap[componentVertical] || '/'
  }

  return customUrl
})

const pillClass = computed(() => {
  return props.theme === 'dark'
    ? '!bg-white !border-white !text-semantic-inverse-surface !shadow-none hover:!bg-base-lavender-100 hover:!border-base-lavender-100 hover:!text-semantic-inverse-surface'
    : '!bg-semantic-primary-default !border-semantic-primary-default !text-semantic-surface-default !shadow-none hover:!bg-semantic-primary-variant-light hover:!border-semantic-primary-variant-light hover:!text-semantic-surface-default'
})
</script>
